<template>
  <div class="basic_wrap">
    <bsHeader
      :title="$t('user.faq')"
      @backurl="$router.back()"
    />
    
    <div class="main_wrap">
      <!-- ================= 常见问题列表 ================= -->
      <div class="list_wrap">
        <div 
          v-for="(item, index) in data.list" 
          :key="index"
          class="card_item"
          @click="$router.push('article/' + item.id)"
        >
          <span class="item_title">{{ item.title }}</span>
          <span class="item_arrow">›</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import bsHeader from '../../components/bsHeader.vue'
import Fetch from '../../utils/fetch'
import { Cell, CellGroup } from 'vant';
Vue.use(Cell).use(CellGroup);

export default {
  name: "Questions",
  components: {
    bsHeader
  },
  data() {
    return {
      data: [],
    };
  },
  created() {
    if (window.plus) {
      plus.navigator.setStatusBarBackground('#FFFFFF');
      plus.navigator.setStatusBarStyle('dark');
    }
    this.$parent.footer('user', false);
  },
  mounted() {
    Fetch('/index/questions').then(r => {
      this.data = r.data;
    })
  },
  methods: {}
};
</script>

<style lang="less" scoped>
/* ================= 全局基础样式 ================= */
.basic_wrap {
  height: 100vh;
  /* 浅蓝网格纹理 */
  background: linear-gradient(180deg, #f8fbff, #eef4fb 42%, #f6f8fc);
}

.main_wrap {
  padding: 16px;
}

/* ================= 卡片列表 ================= */
.list_wrap {
  display: flex;
  flex-direction: column;
  gap: 14px; /* 卡片之间的间距 */

  .card_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    background: #ffffff;
    border-radius: 18px;
    padding: 18px 20px;
    box-shadow: 0 2px 8px rgba(24, 61, 122, 0.04);
    border: 1px solid rgba(176, 202, 240, 0.2);
    cursor: pointer;
    transition: all 0.2s;

    &:active {
      transform: scale(0.98);
      background: #f8faff;
    }

    /* 左侧文字 */
    .item_title {
      font-size: 15px;
      font-weight: 700;
      color: #1a2742;
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    /* 右侧箭头 */
    .item_arrow {
      font-size: 20px;
      color: #94a3b8;
      font-weight: 300;
      margin-left: 12px;
      flex-shrink: 0;
      line-height: 1;
    }
  }
}
</style>